// Client-safe media URL helper (trimmed from portal). DB stores object KEYS
// (private R2/MinIO); a raw <img src> must never be a key. mediaSrc() maps a
// stored value to a STABLE same-origin proxy URL (/api/media/proxy?key=…) that
// 302-redirects to a freshly-signed presigned URL. Passes data:/blob:/already-
// proxied/public URLs through untouched.

const PRIVATE_STORAGE_HOST_SUFFIXES = [".blob.core.windows.net", ".r2.cloudflarestorage.com"];

export function isPrivateStorageRef(ref?: string | null): boolean {
  if (!ref) return false;
  if (ref.startsWith("data:") || ref.startsWith("blob:") || ref.startsWith("/api/media/")) {
    return false;
  }
  if (!/^https?:\/\//i.test(ref)) return true; // bare key
  try {
    const host = new URL(ref).hostname.toLowerCase();
    return PRIVATE_STORAGE_HOST_SUFFIXES.some((s) => host.endsWith(s));
  } catch {
    return false;
  }
}

export interface MediaSrcOpts {
  download?: boolean;
  filename?: string;
}

/** Servable URL for a stored media value (proxy for private, passthrough otherwise). */
export function mediaSrc(ref?: string | null, opts: MediaSrcOpts = {}): string {
  if (!ref) return "";
  if (!isPrivateStorageRef(ref)) return ref;

  const params = new URLSearchParams({ key: ref });
  if (opts.download) params.set("download", "1");
  if (opts.filename) params.set("filename", opts.filename);
  return `/api/media/proxy?${params.toString()}`;
}
